export type SectionItem = { slug: string; en: string; zh: string };
export type SectionGroup = { headerEn: string; headerZh: string; items: SectionItem[] };

export const products: SectionItem[] = [
  { slug: "oranhub", en: "OranHub", zh: "OranHub" },
  { slug: "oransim", en: "OranSim", zh: "OranSim" },
  { slug: "orangen", en: "OranGen", zh: "OranGen" },
  { slug: "oranmed", en: "OranMed", zh: "OranMed" },
  { slug: "orangeo", en: "OranGEO", zh: "OranGEO" },
];

export const solutions: SectionGroup[] = [
  {
    headerEn: "Solutions",
    headerZh: "解决方案",
    items: [
      { slug: "strategy-insight", en: "Strategy Insight", zh: "策略洞察" },
      { slug: "ad-optimization", en: "Ad Optimization", zh: "广告优化" },
      { slug: "ad-design", en: "Ad Design", zh: "广告设计" },
      { slug: "geo", en: "GEO", zh: "GEO" },
    ],
  },
];
